export default __webpack_public_path__ + "static/media/Calendar.a533ff3f.svg";